import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormTristateField } from '@grupo-constant/next-dtype/form';
import { BooleanTristateValue, DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'tristate-field-component',
    templateUrl: './tristate-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeTristateFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormTristateField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    trueValue = BooleanTristateValue.TRUE;
    falseValue = BooleanTristateValue.FALSE;
    unanswredValue = BooleanTristateValue.UNANSWERED;

    constructor() { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

}
